import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { BsChevronDown } from "react-icons/bs";

export default function SelectTag({ item }) {
  const { label, name, defaultValue, required, options, fullWidth } = item;
  const [selected, setSelected] = useState(defaultValue || "Select ");
  const icons = options?.length > 0 ? options : ["No data available"];

  return (
    <div className="col-span-4 w-full">
      <div
        className={`${
          fullWidth
            ? "w-full max-w-[388px]"
            : "w-full sm:w-fit min-w-[200px] sm:min-w-[240px]"
        } -mr-2`}
      >
        <label htmlFor={name} className="label capitalize">
          <span className="text-md font-semibold text-darkPrimary dark:text-darkWhite">
            {label}
          </span>
          {required && <span className="text-red-500 text-lg">*</span>}
        </label>
        <input type="hidden" name={name} value={selected} hidden />
        <Listbox value={selected} onChange={setSelected}>
          <div className="relative mt-2">
            <Listbox.Button className="relative w-full rounded-md py-2.5 px-3 text-left bg-transparent outline-none border border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 focus:border-secondary dark:focus:border-secondary transition-colors duration-150 focus:outline-none flex justify-between items-center cursor-pointer">
              <span className="block truncate capitalize dark:text-darkWhite">
                {selected}
              </span>
              <BsChevronDown className="block text-gray-400" />
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white  dark:bg-darkPrimary py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50">
                {icons?.map((item, itemIdx) => (
                  <Listbox.Option
                    key={itemIdx}
                    className={({ active }) =>
                      `relative select-none py-2 px-3 cursor-pointer ${
                        active
                          ? "bg-primary dark:bg-gray-700 text-gray-900 dark:text-darkWhite"
                          : "text-gray-900 dark:text-darkWhite"
                      }`
                    }
                    value={item}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate capitalize ${
                            selected
                              ? "font-semibold text-secondary"
                              : "font-medium"
                          }`}
                        >
                          {item}
                        </span>
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
      </div>
    </div>
  );
}
